/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Systems_HomeInputs */

const en_common_systems_home = /** @type {(inputs: Common_Systems_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const zh_common_systems_home = /** @type {(inputs: Common_Systems_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Common_Systems_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_systems_home = /** @type {((inputs?: Common_Systems_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Systems_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_systems_home(inputs)
	return zh_common_systems_home(inputs)
});
export { common_systems_home as "common.systems.home" }